@if (visible) {
  <div class="modal-overlay" (mousedown)="onOverlayClick()">
    <div class="modal-card betreuer-card wide" role="dialog" aria-modal="true"
         aria-labelledby="advisors-modal-title"
         (mousedown)="$event.stopPropagation()"
         cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
      <div class="modal-head">
        <div>
          <div class="modal-sub">{{ 'adminDash.advisors.sub' | translate }}</div>
          <div class="modal-title" id="advisors-modal-title">{{ 'adminDash.advisors.title' | translate }}</div>
        </div>
        <button class="modal-x" type="button" [attr.aria-label]="'general.close' | translate" (click)="close()">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6l-12 12"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="edit-intro">{{ 'adminDash.advisors.intro' | translate }}</p>

        <div class="bt-firma-head">
          <span class="bt-firma-count">{{ 'adminDash.advisors.summary' | translate: {count: rows.length} }}</span>
          <button class="btn-text accent bt-add" type="button" (click)="addAdvisor()">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                 stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            {{ 'adminDash.advisors.add' | translate }}
          </button>
        </div>

        <div class="au-bgrid-head">
          <span>{{ 'adminDash.advisors.col.abbreviation' | translate }}</span>
          <span>{{ 'adminDash.advisors.col.name' | translate }}</span>
          <span>{{ 'adminDash.advisors.col.email' | translate }}</span>
          <span>{{ 'adminDash.advisors.col.companies' | translate }}</span>
          <span>{{ 'adminDash.advisors.col.assigned' | translate }}</span>
          <span>{{ 'adminDash.advisors.col.notification' | translate }}</span>
          <span></span>
        </div>

        @for (a of rows; track a._tempId) {
          <div class="au-brow">
            <input class="bf-input bt-kuerzel-in" type="text"
                   [value]="a.abbreviation || ''" readonly
                   placeholder="ABC"
                   [attr.aria-label]="'adminDash.advisors.col.abbreviation' | translate">
            @if (a.userId) {
              <input class="bf-input bf-input-readonly" type="text"
                     [value]="nameOf(a)" readonly
                     [attr.aria-label]="'adminDash.advisors.col.name' | translate">
            } @else {
              <input class="bf-input" type="text"
                     [ngModel]="nameOf(a)" (ngModelChange)="onNameInput(a, $event)"
                     [placeholder]="'adminDash.advisors.namePlaceholder' | translate"
                     [attr.aria-label]="'adminDash.advisors.col.name' | translate"
                     [matAutocomplete]="userAuto">
              <mat-autocomplete #userAuto="matAutocomplete"
                                (optionSelected)="onUserSelected(a, $event.option.value)">
                @for (u of filteredUsers(a); track u.id) {
                  <mat-option [value]="u">{{ userLabel(u) }}</mat-option>
                }
              </mat-autocomplete>
            }
            <input class="bf-input bf-input-readonly" type="email"
                   [value]="a.email || ''" readonly
                   [attr.aria-label]="'adminDash.advisors.col.email' | translate">
            <div class="au-firm-toggles">
              @for (c of companies; track c.id) {
                <button class="au-ftog" type="button"
                        [attr.aria-pressed]="hasFirm(a, c.id)"
                        [ngStyle]="toggleStyle(c, hasFirm(a, c.id))"
                        (click)="toggleFirm(a, c.id)">
                  {{ c.abbreviation }}
                </button>
              }
            </div>
            <span class="au-usage">{{ 'adminDash.advisors.userCount' | translate: {count: usageOf(a)} }}</span>
            <button type="button" class="tg-switch sm" role="switch"
                    [class.on]="!!a.emailNotification"
                    [attr.aria-checked]="!!a.emailNotification"
                    [attr.aria-label]="'adminDash.advisors.col.notification' | translate"
                    [title]="'adminDash.advisors.notificationHint' | translate"
                    (click)="toggleNotification(a)">
              <span class="tg-track">
                <span class="tg-knob">
                  @if (a.emailNotification) {
                    <svg viewBox="0 0 24 24" width="9" height="9" fill="none" stroke="currentColor"
                         stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <path d="M20 6 9 17l-5-5"/>
                    </svg>
                  }
                </span>
              </span>
            </button>
            <button class="of-del" type="button"
                    [attr.aria-label]="'adminDash.advisors.remove' | translate"
                    [title]="'adminDash.advisors.remove' | translate"
                    (click)="removeAdvisor(a)">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                   stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 7h16M10 11v6M14 11v6"/>
                <path d="M6 7l1 13a2 2 0 002 2h6a2 2 0 002-2l1-13"/>
                <path d="M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
              </svg>
            </button>
          </div>
        }
      </div>

      <div class="modal-foot">
        <span class="modal-count">{{ 'adminDash.advisors.footHint' | translate }}</span>
        <div class="modal-actions">
          <button class="btn-text" type="button" (click)="cancel()">{{ 'general.cancel' | translate }}</button>
          <button class="btn-primary" type="button" [disabled]="isSaving" (click)="save()">
            {{ 'general.save' | translate }}
          </button>
        </div>
      </div>

      @if (pendingRemoval) {
        <div class="migrate-overlay" (mousedown)="cancelPendingRemoval()">
          <div class="migrate-card" role="dialog" aria-modal="true"
               (mousedown)="$event.stopPropagation()"
               (keydown.escape)="cancelPendingRemoval()">
            <div class="migrate-head">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <path d="M12 9v4M12 17h.01"/>
              </svg>
              {{ 'adminDash.advisors.deleteConfirm.title' | translate }}
            </div>
            <p class="migrate-text">
              {{ 'adminDash.advisors.deleteConfirm.text' | translate: {
                abbr: pendingRemoval.row.abbreviation || '',
                name: nameOf(pendingRemoval.row),
                count: pendingUsageCount,
                userWord: (pendingUsageCount === 1
                  ? 'adminDash.advisors.deleteConfirm.userSingular'
                  : 'adminDash.advisors.deleteConfirm.userPlural') | translate: {count: pendingUsageCount}
              } }}
            </p>
            @for (g of pendingRemoval.groups; track g.companyId) {
              <div class="migrate-group">
                <div class="migrate-group-head">
                  @if (g.companyId) {
                    <span class="migrate-group-firma">{{ companyById(g.companyId)?.abbreviation || '—' }}</span>
                  } @else {
                    <span class="migrate-group-firma">
                      {{ 'adminDash.advisors.deleteConfirm.noCompanyGroup' | translate }}
                    </span>
                  }
                  <span class="migrate-group-count">
                    {{ 'adminDash.advisors.userCount' | translate: {count: g.userIds.length} }}
                  </span>
                </div>
                <select class="bf-input" [(ngModel)]="g.targetAdvisorId"
                        [attr.aria-label]="'adminDash.advisors.deleteConfirm.reassign' | translate">
                  <option [ngValue]="null" disabled>
                    {{ 'adminDash.advisors.deleteConfirm.choose' | translate }}
                  </option>
                  @for (t of migrationTargetsFor(g.companyId); track t._tempId) {
                    <option [ngValue]="t.id">
                      @if (leadsCompany(t, g.companyId)) {
                        {{ t.abbreviation || '—' }} — {{ nameOf(t) }}
                      } @else {
                        {{ t.abbreviation || '—' }} — {{ nameOf(t) }}
                        · {{ 'adminDash.advisors.deleteConfirm.assignsCompany' | translate }}
                      }
                    </option>
                  }
                </select>
                @if (g.targetAdvisorId === null) {
                  <p class="migrate-warning" role="alert">
                    @if (migrationTargetsFor(g.companyId).length === 0) {
                      {{ 'adminDash.advisors.deleteConfirm.noTargets' | translate: {count: g.userIds.length} }}
                    } @else {
                      {{ 'adminDash.advisors.deleteConfirm.targetRequired' | translate: {count: g.userIds.length} }}
                    }
                  </p>
                }
              </div>
            }
            <div class="migrate-actions">
              <button class="btn-text" type="button" (click)="cancelPendingRemoval()">
                {{ 'general.cancel' | translate }}
              </button>
              <button class="btn-primary" type="button"
                      [disabled]="!pendingRemovalResolved"
                      (click)="confirmPendingRemoval()">
                {{ 'adminDash.advisors.deleteConfirm.confirm' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
